import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const allotmentApi = createApi({
  reducerPath: "allotmentApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["CampusStockAllotments"],
  endpoints: (builder) => ({
    getCampusStockAllotments: builder.query({
      providesTags: ["CampusStockAllotments"],
      query: ({ page = 1, limit = 10, search = "", category, showAll, fromDate, toDate } = {}) => ({
        url: "/itemstockallotment/campus",
        method: "GET",
        params: {
          page,
          limit,
          ...(search ? { search } : {}),
          ...(category ? { category } : {}),
          ...(showAll ? { showAll } : {}),
          ...(fromDate ? { fromDate } : {}),
          ...(toDate ? { toDate } : {}),
        },
      }),
    }),
    getAllAllotmentsAdminSide: builder.query({
      providesTags: ["CampusStockAllotments"],
      query: ({ campusId, page = 1, limit = 10, search = "", category = "", showAll, fromDate, toDate }) => ({
        url: `/itemstockallotment/admin/${campusId}`,
        method: "GET",
        params: {
          page,
          limit,
          ...(search && { search }),
          ...(category ? { category } : {}),
          ...(showAll ? { showAll } : {}),
          ...(fromDate ? { fromDate } : {}),
          ...(toDate ? { toDate } : {}),
        },
      }),
    }),
  }),
});

export const {
  useGetCampusStockAllotmentsQuery,
  useLazyGetCampusStockAllotmentsQuery,
  useGetAllAllotmentsAdminSideQuery,
  useLazyGetAllAllotmentsAdminSideQuery,
} = allotmentApi;
